import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { storage, db } from '../FireBase'; // Import Firestore and Storage
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, updateDoc, query, where, getDocs, doc } from 'firebase/firestore';
import ToastAlert from './ToastAlert';

const DiscontinueSchemeModal = ({ show, onHide, schemeId, customerId,onDiscontinue,subscriptionId,onSuccess }) => {
    const [notes, setNotes] = useState('');
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            let fileURL = '';
            if (file) {
                const storageRef = ref(storage, `settlement_proofs/${file.name}`);
                await uploadBytes(storageRef, file);
                fileURL = await getDownloadURL(storageRef);
            }
            console.log(subscriptionId)
            const discontinueData = {
                schemeId,
                customerId,
                notes,
                fileURL,
                discontinuedAt: new Date(),
                status:'discontinued',
                isActive: false
            };

            
            const subscriptionsQuery = query(
                collection(db, 'subscriptions'),
                where('userId', '==', customerId),
                where('schemeId', '==', schemeId),
                where('subscriptionId', '==', subscriptionId),
            );
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
    
            if (!subscriptionsSnapshot.empty) {
                const subscriptionDoc = subscriptionsSnapshot.docs[0];
                const subscriptionRef = doc(db, 'subscriptions', subscriptionDoc.id);
                await updateDoc(subscriptionRef, {
                    status: 'discontinued',
                    isActive: false,
                    discontinueData
                });
                onDiscontinue(customerId, discontinueData);
            }
            setToastMessage(`${customerId} Discontinued successfully`);
            setToastVariant('success'); // Use 'danger' for the alert variant

            setShowToast(true);
            setLoading(false);
            onHide();
            onSuccess();
        } catch (error) {
            console.error('Error discontinuing scheme:', error);
            setLoading(false);
        }
    };

    return (
        <>
         <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
       
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Discontinue Scheme</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="notes">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="file">
                        <Form.Label>Upload Settlement Proof</Form.Label>
                        <Form.Control type="file" onChange={handleFileChange} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit'}
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
};

export default DiscontinueSchemeModal;